import React from 'react';
import { connectToStore } from '../../store';
import QuestionCopy from '../common/QuestionCopy';
import NumericalSelect from '../common/NumericalSelect';
import { extractPrevItemKeyFromPath } from '../../lib/utilities';
import styles from './QuestionWorkAffected.module.css';

function updateAnswer(actions, activeItem, formData, newValue) {
	formData[`impact.work`] = newValue;
	actions.updateFormData(formData);
	// actions.goToNextItem(activeItem, formData);
}

function QuestionWorkAffected({ state, actions }) {
	const { activeItem, formData } = state;

	return (
		<section className={styles.question}>
			<article>
				<QuestionCopy
					questionNum={activeItem.questionNum}
					title="Has your ability to WORK been impacted? *"
				/>
				<NumericalSelect
					minValue="1"
					maxValue="5"
					minLabel="Not at all"
					maxLabel="Daily struggle"
					value={formData[`impact.work`]}
					onChange={(newValue) => updateAnswer(actions, activeItem, formData, newValue)}
				/>
			</article>
		</section>
	);
}

QuestionWorkAffected.getPrevItemKey = (_, itemPath) => extractPrevItemKeyFromPath(itemPath);

QuestionWorkAffected.getNextItemKey = (formData) => {
	return (formData[`impact.work`] ? `QuestionRelationshipsAffected` : undefined);
};

QuestionWorkAffected.getAllowSubmit = () => false;

export default connectToStore(QuestionWorkAffected);
